import script from "./AiProjectManagementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AiProjectManagementTable.vue?vue&type=script&setup=true&lang=js"

import "./AiProjectManagementTable.vue?vue&type=style&index=0&id=5e64f576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e64f576"]])

export default __exports__